import React from "react";
import { ResellerPageStyle } from "../../pages/Reseller/Reseller.styled";
import moment from "moment";

const Table = ({ tableName, status, data = [] }) => {
  return (
    <ResellerPageStyle>
      <div className="table-div2">
        <table className="table table-hover">
          <thead className="table-head">
            <tr>
              <th scope="col">#</th>
              <th scope="col">{tableName}</th>
              <th scope="col">Status</th>
              <th scope="col">Email</th>
              <th scope="col">Account Creation Date</th>
              <th scope="col">Subscription Type</th>
              <th scope="col">Subscription Status</th>
              <th scope="col">Subscription Start Date</th>
              <th scope="col">Subscription End Date</th>
              <th scope="col">Promo Code</th>
            </tr>
          </thead>
          <tbody>
            {status ? (
              <tr>
                <td colSpan={10}>
                  <p className="table-loading">Loading...</p>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={10}>
                  <p className="table-loading">No Data Available</p>
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                return (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td className="item2">{item.id}</td>
                    <td className="item2">{item.status}</td>
                    <td className="item2">{item.email}</td>
                    <td className="item2">
                      {item.accountCreationDate
                        ? moment(item.accountCreationDate).format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="item2">{item.plan}</td>
                    <td className="item2">{item.subStatus}</td>
                    <td className="item2">
                      {item.subscriptionStart
                        ? moment(item.subscriptionStart).format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="item2">
                      {item.subscriptionEnd
                        ? moment(item.subscriptionEnd).format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="item2">{item.promoCode}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </ResellerPageStyle>
  );
};

export default Table;
